<template>
  <div class="dropdown d-inline ">
    <Button id="stockProductWarehouseFilter" color="primary" variant="outline" :title="$t('key_warehouses')" class="dropdown-toggle ms-2 " :class="warehouseSelected == '' ? '' : 'active-filter'"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-warehouse me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="stockProductWarehouseFilter">
      <li v-for="(item, index) of warehousesData?.items || []" :key="index">
        <button class="dropdown-item border-radius-md text-warehouses" :class="[filterWarehouseSelected==item.name?'active':'']" type="button" @click="handleClick(item.name)">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-warehouse me-3"></i>
          </span>
          <span class="btn-inner--text">{{ item.name }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_purchaseStatusFilter_clearFilter') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

  import { mapState, mapActions } from "vuex";
  import Button from "./../../../../generic_components/Button.vue";

  export default {
    name:"StockProductWarehouseFilter",
    components: {
      Button
    },
    props: {
      filterWarehouseSelected: {
        type: String,
        default: () => ''
      }
    },
    emits: ['stock-product-warehouse-filter-change'],
    data() {
      return {
        myAccount: JSON.parse(localStorage.getItem("user")),
        filters: {
          search: '',
          status: '',
          sort: {
            sort: '',
            order: ''
          }
        },
        isLoading: false,
        pagination: {
          total: 0,
          rows: 200,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50, 100, 200]
        },
        warehouseSelected: ""
      }
    },
    computed: {
      ...mapState('warehouse', {
        warehousesData: state => state.list.data,
        warehousesResponse: state => state.list.response,
        warehousesStatus: state => state.list.status
      })
    },
    watch: {
      filterWarehouseSelected() {
        this.warehouseSelected = this.filterWarehouseSelected;
      },
      warehousesResponse() {
        if(this.warehousesData) {
          this.pagination.total = this.warehousesData.total;
          this.isLoading = false;
        }
      }
    },
    mounted () {
      this.getWarehousesList();
    },
    methods: {
      ...mapActions('warehouse', [
                             'getWarehouses'
                            ]),
      async getWarehousesList() {
        if (this.warehousesStatus === 'loading' || this.isLoading) {
          return;
        }
        
        this.isLoading = true;
        try {
          await this.getWarehouses({filters: this.filters, pagination: this.pagination});
          
          if (this.warehousesStatus === 'success' && this.warehousesResponse.status === 200 && this.myAccount.notifications) {
            this.$notify({
              title: this.$t('key_header_successful_retrieving_data'),
              message: this.$t('key_message_successful_retrieving_data'),
              icon: { component: 'fa-solid fa-check', color: 'white' },
              color: 'success',
              show: true,
              duration: 5000
            });
          } else if(this.warehousesStatus !== 'success') {
            this.$notify({
              title: this.$t('key_header_error_retrieving_data'),
              message: this.$t('key_message_error_retrieving_data'),
              icon: { component: 'fa-solid fa-xmark', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t('key_header_error_unexpected'),
            message: this.$t('key_message_error_unexpected'),
            icon: { component: 'fa-solid fa-xmark', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000
          });
        } finally {
          this.isLoading = false;
        }
      },
      handleClick(warehouse) {
        this.warehouseSelected = warehouse;
        this.$emit('stock-product-warehouse-filter-change', warehouse);

        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      },
    }
  }

</script>

<style scoped>

  .active{
    background-color: rgb(234, 244, 247) !important;
  }
  .active-filter {
    color: #fff;
    background-color: #42695c;
    border-color: #42695c;
  }

</style>